import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  HttpError,
  VerifyCustomerExistPayload,
  VerifyCustomerExistResponse
} from '@eo-storefronts/eo-core'
import { useState } from 'react'
import { verifyCustomerExist } from '~/src/services/AuthenticationService'
import { default as parsePhoneNumber } from 'libphonenumber-js'
import useGetEmailReturnUrl from '~/src/hooks/router/useGetEmailReturnUrl'
import RoutesEnum from '~/src/router/enums/routes.enum'

interface ReturnsType {
  errors: Record<string, string[]> | string | null,
  loading: boolean,
  verify(payload: VerifyCustomerExistPayload): Promise<VerifyCustomerExistResponse | undefined>,
}

const useVerifyCustomerExist = (): ReturnsType => {
  const [ errors, setErrors ] = useState<Record<string, string[]> | string | null>(null)
  const [ loading, setLoading ] = useState<boolean>(false)
  const { generateReturnUrl } = useGetEmailReturnUrl()

  const _clearPhoneNumber = (value: string | null | undefined): string | null => {
    if (!value) {
      return null
    }

    return parsePhoneNumber(value)?.number || null
  }

  const verify = async (payload: VerifyCustomerExistPayload): Promise<VerifyCustomerExistResponse | undefined> => {
    setErrors(null)
    setLoading(true)

    try {
      const verifyResponse: VerifyCustomerExistResponse = await verifyCustomerExist(
        {
          email: payload.email,
          phone: _clearPhoneNumber(payload.phone) ? payload.phone : null
        },
        generateReturnUrl(RoutesEnum.ACTIVATE_ACCOUNT),
      )

      return verifyResponse
    } catch (e: any | HttpError) {
      if (e?.errors) {
        setErrors(e.errors)
      } else if (e?.message) {
        setErrors(e.message)
      }

      throw e
    } finally {
      setLoading(false)
    }
  }

  return {
    errors,
    loading,
    verify
  }
}

export default useVerifyCustomerExist
